import request, { platformRead } from './http';

// 列表运行态使用平台分页查询；POST _query / _count 均为只读查询。
export const queryFleetProducts = (data, options = {}) => platformRead({ url: '/jetlinks/device-product/_query', method: 'post', data }, options);
export const queryFleetDevices = (data, options = {}) => platformRead({ url: '/jetlinks/device-instance/_query', method: 'post', data }, options);
export const countFleetDevices = (data, options = {}) => platformRead({ url: '/jetlinks/device-instance/_count', method: 'post', data }, options);
export const query = (data) => request({
  url: "/jetlinks/visualization/_query",
  method: 'POST',
  data: data
});

export const addObj = (data) => request({
  url: "/jetlinks/visualization",
  method: 'POST',
  data: data
});

// 文件导入由后端重建项目身份并初始化独立草稿，不回退普通新增。
export const importScreenProject = (data) => request({
  url: '/jetlinks/visualization/_import',
  method: 'POST',
  data
});

export const updateObj = (data) => request({
  url: "/jetlinks/visualization/" + data.id,
  method: 'PUT',
  data: data
});

export const delObj = (id) => request({
  url: "/jetlinks/visualization/" + id,
  method: 'DELETE'
});

export const getObj1 = (id, options = {}) => request({
  ...options,
  url: "/jetlinks/visualization/" + id,
  method: 'GET'
});

export const updateComponent = (id, data) => request({
  url: '/jetlinks/visualization/'+ id,
  method: 'PUT',
  data: data
});
//获取设备列表
export const deviceList = (params) => request({
  url: '/jetlinks/device-instance/_query',
  method: 'get',
  params
})

export const deviceListNoPage = (params, options = {}) => request({
  ...options,
  url: '/jetlinks/device-instance/_query/no-paging?paging=false',
  method: 'get',
  params
})

export const productListNoPage = (params, options = {}) => request({
  ...options,
  url: '/jetlinks/device-product/_query/no-paging',
  method: 'get',
  params
})

//获取属性列表
export const propertyList = (id) => request({
  url: '/jetlinks/device/instance/'+id+'/detail',
  method: 'get'
})

//获取视频流设备
export const getVideoDeviceListNoPaging = () => request({
  url: '/jetlinks/media/device/_query/no-paging',
  method: 'get'
})
//获取通道
export const getVideoChannelListNoPaging = (params) => request({
  url: '/jetlinks/media/channel/_query/no-paging',
  method: 'get',
  params
})
// 复制
export const copyObj = (id) => request({
  url: "/jetlinks/visualization/copy/" + id,
  method: 'POST'
});
//播放
// export const startVideo = (deviceId, channelId) => request({
//   url: '/jetlinks/media/device/'+ deviceId +'/'+ channelId+'/_start',
//   method: 'post'
// })

